// axios
import axios from 'axios'
import {BASE_URL} from '@/urls.js'

//const baseURL = 'https://dev.tacna.net/internal_api/'
// const baseURL = 'https://dev.tacna.net/internal_api/'
// const baseURL = 'http://test.tacna.net:4444/internal_api/'
//const baseURL = 'https://portal.tacna.net/internal_api/'

const baseURL = `${BASE_URL  }internal_api/`

export default axios.create({
  baseURL,
  //headers:{'Authorization': `Bearer ${localStorage.accessToken}`}
  // You can add your headers her
})
